import axios from 'axios';
// utils
import { API_URL } from 'config';
import { getCookie } from 'utils/cookie';

axios.defaults.baseURL = API_URL + '/api/v1/dashboard';
axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.params = {};
axios.defaults.params['user_key'] = getCookie('user_token');

const apiCall = ({ method = 'get', url, baseURL, ...options }) => {
  // Use the custom baseURL if provided, otherwise fall back to the default
  return axios({
    method,
    url,
    baseURL: baseURL || axios.defaults.baseURL,
    ...options,
  });
};

export default apiCall;
